export const HOME = "home";
export const ABOUT = "about";
export const CONTACT = "contact";
export const SERVICE = "service";

